import React from 'react';
import { CTAButton, PRICE_SHORT, Section } from './Shared';
import { Blossom, Daisy, FlowerSpike, Sprig } from './FloralDecor';
export function ClosingCTA() {
  return <Section className="max-w-4xl" data-id="element-25" data-mp="2i8ak82j6heba">
      <div className="relative overflow-hidden rounded-xl border border-emerald-200 bg-emerald-50 px-6 py-10 text-center md:px-12 md:py-14" data-id="element-26" data-mp="2i9c7r6hdrt9w">
        <Blossom className="pointer-events-none absolute -left-6 -top-6 h-32 w-32" petalClassName="text-pink-300/60" centerClassName="text-amber-300" data-id="element-27" data-mp="2n9ge43okr7me" />
        <Sprig className="pointer-events-none absolute -bottom-8 -right-4 h-48 w-28 text-emerald-600/25" data-id="element-28" data-mp="3fv9ighpiquba" />
        <Daisy className="pointer-events-none absolute right-[8%] top-6 hidden h-14 w-14 md:block" petalClassName="text-white" centerClassName="text-amber-400" data-id="element-29" data-mp="3152c30csd1qy" />
        <FlowerSpike className="pointer-events-none absolute -bottom-4 left-[6%] hidden h-36 w-10 md:block" petalClassName="text-fuchsia-300/60" centerClassName="text-emerald-400/50" data-id="element-30" data-mp="3ttpp68ndsktf" />
        <div className="relative" data-id="element-31" data-mp="r4pg6g8psrwt">
          <h2 className="text-3xl font-bold leading-tight tracking-tight text-emerald-900 md:text-4xl" data-id="element-32" data-mp="r5qnqaqiuw9s">
            Keep a clear reference close at hand
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-stone-700 md:text-lg" data-id="element-33" data-mp="113564fw09v4q">
            Bring the consultation framework, formula studies, case examples, record pages, reflection tools, and
            business-planning resources together in one English-language library.
          </p>
          <div className="mt-8" data-id="element-34" data-mp="1oszfgnh491k8">
            <CTAButton variant="gold" className="px-7 text-base md:px-10 md:text-lg" data-id="element-35" data-mp="1orxt3mungsn7">
              GET THE COMPLETE GUIDE — {PRICE_SHORT}
            </CTAButton>
          </div>
          <p className="mt-4 text-xs text-stone-500 md:text-sm" data-id="element-36" data-mp="3qj18epfhive3">
            One-time payment · Digital PDF access · 7-day refund policy
          </p>
        </div>
      </div>
    </Section>;
}